<div class="no-content">
  <!-- image -->
  <img
    class="no-content__img"
    ngSrc="assets/images/smile.png"
    width="80"
    height="80"
    alt="" />
  <!-- content -->
  <p class="no-content__text">{{ message() | translate }}</p>
</div>
